import { TextField } from "@mui/material";
import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";

RHFTextField.propTypes = {
  name: PropTypes.string,
};

export default function RHFTextField({ name, sx,shouldUnregister=false, ...other }) {
  const { control } = useFormContext();
  return (
    <Controller
      shouldUnregister={shouldUnregister}
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          error={!!error}
          helperText={error?.message}
          {...other}
        />
      )}
    />
  );
}
